import { render, staticRenderFns } from "./DetalleTransaccion.vue?vue&type=template&id=3e45b1ca&"
import script from "./DetalleTransaccion.vue?vue&type=script&lang=js&"
export * from "./DetalleTransaccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports